<template>
  <div class="appMain">
    <el-row  class="mainRow">
      <transition name="fade-transform" mode="out-in">
        <router-view :key='key'></router-view>
      </transition>
    </el-row>
    <!-- <el-card class="box-card">
      <router-view></router-view>
    </el-card> -->

  </div>
</template>

<script>
  export default{
    computed:{
      key() {
        return this.$route.path
      }
    }
  }
</script>

<style scoped>
.mainRow{
  background-color: #fff;
  padding: 10px;
  border: 1px #d9d9d9 solid;
}
</style>
